<template>
    <div>
        <template v-if="component">
            <component :is="component" @action="handleUserAction" v-bind="componentProps" :show="show"></component>
        </template>
    </div>
</template>

<script setup lang="ts">
import { nextTick, ref, shallowRef, type Component } from 'vue';

const component  = shallowRef<null | Component>(null)
const componentProps = ref<any>({})

const show = ref(false)

let resolveFunction : null | Function = null

async function showModal(_component: Component, _componentProps?: any) {


    componentProps.value = _componentProps
    await nextTick()
    component.value = _component
    await nextTick()
    show.value = true
    
    return new Promise((resolve) => {
        resolveFunction = resolve
    })
    
}

async function handleUserAction(data : any) {
    show.value = false

    await nextTick()
    if(!resolveFunction) return
    resolveFunction(data)
    resolveFunction = null
    component.value = null
    componentProps.value = {}

}

defineExpose({
    showModal
})

</script>

<style scoped>

</style>